import React from 'react'
import { useNavigate } from 'react-router-dom';

import classes from './../Onboarding.module.scss';
import UpperDiv from './UpperDiv';
import LowerDiv from './LowerDiv';
import allow_camera from './../../../assets/onboarding/allow_camera.svg'
import allow_location from './../../../assets/onboarding/allow_location.svg'
import allow_svg from './../../../assets/onboarding/allow_1.svg'
import Pagination from './Pagination';

const upperDivStyle = {
  display: "flex",
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: 0
}

const lowerDivStyle = {
  display: "flex",
  flexDirection: 'column',
  gap: '0'
}

const allow_pic_1_style = {
  maxWidth: '25%',
}

const Page2 = () => {
  const navigate = useNavigate();

  return (
    <>
      <UpperDiv style={upperDivStyle}>
        <img src={allow_camera} alt="" style={{ maxWidth: "90%" }} />
        <img src={allow_location} alt="" style={{ maxWidth: "90%" }} />
      </UpperDiv>
      <LowerDiv style={lowerDivStyle}>
        <div className={classes.Page2Div}>
          <img src={allow_svg} alt="" style={allow_pic_1_style} />
          <h3 className={classes.Page2H3}>
            Allow Permissions
          </h3>
          <p className={classes.NameH3}>
            Allow the permission to fetch your location and
            use your Mobile Camera for using the App.
          </p>
        </div>
        <div className={classes.Page2Pagination}>
          <div style={{ display: 'flex' , width:"100%"}}>
            <button onClick={() => { navigate('/onboarding/1') }}>
              PREV
            </button>
            <button onClick={() => { navigate('/onboarding/3') }}>
              NEXT
            </button>
          </div>
          <Pagination numberOfDots={7} activePage={2} />
        </div>
      </LowerDiv>
    </>
  )
}

export default Page2